import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, Button, App, Row, Col, Modal, Tabs } from 'antd';
import { GET, POST } from '../../utils/apicalls';
import { API } from '../../config/api';
import Header from '../componets/header/header';
import Footer from '../componets/footer/footer';
import course1 from "../../assets/course1.webp";
import defalut from "../../assets/fixed_mage.png";
import cfs1 from "../../assets/cfs1.jpg";
import cfs2 from "../../assets/cfs2.png";
import course3 from "../../assets/course2.webp";
import course4 from "../../assets/course3.webp";
import courseback from "../../assets/course-back.jpg";
import cfsbody from "../../assets/CFSBody.png";

// @ts-ignore
import "./viewCourseDetails.css";
import EligibilityCheckForm from './eligibilitycheckForm';
import why1 from '../../assets/why1.webp';
import EnrollModal from '../booking-payment/enrollmentModel';
import loading from '../../assets/loading.gif'
import CourseDisplayCard from './coursepage/courseDisplayCard';
import Ea from './coursepage/ea';
import Cfe from './coursepage/cfe';
import Cfcs from './coursepage/cfcs';
import Cams from './coursepage/cams';
import Ctp from './coursepage/ctp';

function CourseDetails() {
    const { id } = useParams();
    const [courseDetails, setCourseDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [courseExamData, setCourseExamData] = useState<any[]>([]);
    const [courseOutlineData, setCourseOutlineData] = useState<any[]>([]);
    const [courseModuleData, setCourseModuleData] = useState<any[]>([]);
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [isEligibilityModalOpen, setIsEligibilityModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('exam');
    const [openSection, setOpenSection] = useState<string | null>(null);
    const [showAllOutlines, setShowAllOutlines] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const filterCourseecxamData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE_EXAM;
            const response: any = await POST(api, values);

            if (response?.status && response.data.length > 0) {
                setCourseExamData(response.data);
            } else {
                setCourseExamData([]);
            }
        } catch (error) {

            notification.error({ message: "An error occurred while filtering." });
        } finally {
            setIsLoading(false);
        }
    };

    const filterCourseoutlineData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE_OUTLINE;
            const response: any = await POST(api, values);

            if (response?.status && response.data.length > 0) {
                setCourseOutlineData(response?.data);
            } else {
                setCourseOutlineData([]);
            }
        } catch (error) {
            console.log(error);
            notification.error({ message: "An error occurred while filtering." });
        } finally {
            setIsLoading(false);
        }
    };
    const filterCourseData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE_MODULE;
            const response: any = await POST(api, values);

            if (response?.status && response.data.length > 0) {
                setCourseModuleData(response.data);
            } else {
                setCourseModuleData([]);
                console.info("No data found for the selected course.");
            }
        } catch (error) {
            console.log(error);
            notification.error({ message: "An error occurred while filtering." });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchCourseDetails = async () => {
            setIsLoading(true);
            try {
                const response: any = await GET(`${API.GET_COURSE_BY_ID}${id}`, {});
                setCourseDetails(response?.data);

                console.log("Course Response:", response);
            } catch (error) {
                console.error("Error fetching course details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchCourseDetails();
            filterCourseData({ Course_id: Number(id) });
            filterCourseoutlineData({ Course_id: Number(id) });
            filterCourseecxamData({ Course_id: Number(id) });
        }
    }, [id]);

    const toggleSection = (section: string) => {
        setOpenSection(prev => (prev === section ? null : section));
    };
    const [expandedCards, setExpandedCards] = useState<{ [key: number]: boolean }>({});

    const toggleReadMore = (index: number) => {
        setExpandedCards((prev) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                name: values.name,
                email: values.email,
                message: values.message,
                phone: values.phone,
                Course_id: Number(id),
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_COURSE_ENQUIRY, obj);

            if (postRequest) {
                notification.success({ message: "Message sent successfully!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const visibleExams = showAll ? courseExamData : courseExamData.slice(0, 3);
    const visibleOutlines = showAllOutlines
        ? courseOutlineData
        : courseOutlineData.slice(0, 3);

    const tabItems = [

        {
            key: 'exam',
            label: <div className="tab-label">Exam Information</div>,
            children: (
                <div className="tab-content exam-tab">
                    <div className="tab-text">
                        {courseExamData ? (
                            <>
                                {visibleExams.length > 0 ? (
                                    visibleExams.map((exam: any, i: number) => (
                                        <div key={i}>
                                            <h3>{exam.ExamTitle || "No Exam Title Available"}</h3>
                                            {exam.ExamFormat && exam.ExamFormat.toLowerCase() !== "none" && (
                                                <p>{exam.ExamFormat}</p>
                                            )}
                                            <ul>
                                                {Array.isArray(exam.ExamDescription) ? (
                                                    exam.ExamDescription.map((desc: string, j: number) => (
                                                        <li key={j}>{desc}</li>
                                                    ))
                                                ) : (
                                                    <li>{exam.ExamDescription || "No description available"}</li>
                                                )}
                                            </ul>
                                        </div>
                                    ))
                                ) : (
                                    <p>No exam data available.</p>
                                )}

                                {courseExamData.length > 3 && (
                                    <button onClick={() => setShowAll(!showAll)}>
                                        {showAll ? "Show Less" : "Read More"}
                                    </button>
                                )}
                            </>
                        ) : (
                            <p>Loading...</p>
                        )}

                    </div>
                    <div className="tab-image">
                        <img src={course1} alt="CFM corporate finance training Kerala,CFS course Kerala" />
                    </div>
                </div>

            ),
        },

        {
            key: 'outcomes',
            label: <div className="tab-label">Course Outcomes</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        {courseOutlineData ? (
                            <>
                                {visibleOutlines.length > 0 ? (
                                    visibleOutlines.map((outline: any, i: number) => (
                                        <div key={i}>
                                            <h3>{outline.courseoutlineTitle || "No Title Available"}</h3>
                                            {Array.isArray(outline.content) &&
                                                outline.content.length > 0 &&
                                                outline.content.some((item: string) => item.trim() !== ".") && (
                                                    <ul>
                                                        {outline.content.map((item: string, index: number) =>
                                                            item.trim() !== "." ? <li key={index}>{item}</li> : null
                                                        )}
                                                    </ul>
                                                )}

                                        </div>
                                    ))
                                ) : (
                                    <p>No course outlines available.</p>
                                )}


                                {courseOutlineData.length > 3 && (
                                    <button onClick={() => setShowAllOutlines(!showAllOutlines)}>
                                        {showAllOutlines ? "Show Less" : "Read More"}
                                    </button>
                                )}
                            </>
                        ) : (
                            <p>Loading...</p>
                        )}

                    </div>
                    <div className="tab-image">
                        <img src={course3} alt="CFM corporate finance training Kerala,CFS course Kerala" />
                    </div>
                </div>

            ),
        },
        {
            key: 'target-audiance',
            label: <div className="tab-label">Target Audiance</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <h2>Target Audience</h2>
                        <ul>
                            {(courseDetails?.targetAudiance || []).map((item: string, index: number) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                        {courseDetails?.subcourse_title === 'CFS' && (
                            <div>
                                <h2>Top reasons to join</h2>
                                <ul>
                                    <li>
                                        Demonstrate your competence and confidence in finance to employers and stakeholders.
                                    </li>
                                    <li>
                                        Earn an affordable qualification recognized in UK framework (SCQF).
                                    </li>
                                    <li>
                                        Enhance global acceptance through a qualification benchmarked against European Qualifications Framework (EQF).
                                    </li>
                                    <li>
                                        Gain a global qualification that is jointly awarded by two reputed brands: International Qualifications Network (IQN) & Scottish Qualifications Authority (SQA).
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="tab-image">
                        <img src={course4} alt="CFM corporate finance training Kerala,CFS course Kerala" />
                    </div>
                </div>
            ),
        },


    ];

    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Update the showModal function
    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation(); // Stop event propagation to prevent navigation
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    // Update the handleCloseModal function
    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null); // Reset selected course when closing
    };


    if (!courseDetails) return <div>No course found.</div>; // Add this line
    const whyTexts = [
        " ACCA & CPA Qualified Faculties",
        // "Official Partner of Hock International USA",
        "Strong Placement History in Big 4s",
        "Premium Online & Offline Batches",
        "Big 4 Alumni as Mentors"
    ];
    const slug = courseDetails?.subcourse_title?.toLowerCase();

    if (slug === 'ea') return <Ea />;
    // if (slug === 'ndt') return <Ndt />;
    if (slug === 'cfe') return <Cfe />;
    if (slug === 'cfcs') return <Cfcs />;
    if (slug === 'cams') return <Cams />;
    if (slug === 'ctp') return <Ctp />;

    return (
        <div className="course-details-page">

            {isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <img src={loading} alt="Loading..." style={{ width: '400px', height: '400px' }} />
                </div>

            ) : (
                <div >
                    <Header />
                    <div className='course-details-container'>
                        <div className="course-hero">
                            <img src={courseback} alt="Course Hero" className="course-hero-image" />
                            <div className="course-hero-overlay"></div>

                            <div className="course-hero-inner">
                                {/* Left Content */}
                                <div className="course-hero-content left-content">
                                    <h1>
                                        {isLoading
                                            ? "Loading..."
                                            : courseDetails?.course_title
                                                ?.replace(/\s*\(.*?\)/, "") || "Course Title"}

                                        {!isLoading && courseDetails?.course_title?.match(/\(.*?\)/) && (
                                            <h1>
                                                {courseDetails.course_title.match(/\(.*?\)/)?.[0]}
                                            </h1>
                                        )}
                                    </h1>

                                    <p><strong>1 Book | 2 Months</strong></p>
                                    <p>Earn up to <strong>5 LPA</strong> in just 2 months!</p>
                                    <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                    <Button
                                        className="courseCard-button primary-button"
                                        type="primary"
                                        onClick={(e) => showModal(id!, e)}
                                    >
                                        Enroll Now
                                    </Button>

                                    {isModalVisible && (
                                        <EnrollModal
                                            visible={isModalVisible}
                                            onClose={handleCloseModal}
                                            courseId={selectedCourseForEnroll}
                                        />
                                    )}
                                </div>

                                {/* Right Form */}
                                <div className="course-hero-content right-form">
                                    <h2 style={{ textAlign: "center" }}>  Make an Enquiry</h2>
                                    <Form
                                        form={form}
                                        layout="vertical"
                                        onFinish={submitHandler}
                                        initialValues={{
                                            name: '',
                                            phone: '',
                                            email: '',
                                            message: '',
                                        }}
                                    >
                                        <Row gutter={24}>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Name"
                                                    name="name"
                                                    rules={[{ required: true, message: 'Please enter your name' }]}
                                                >
                                                    <Input placeholder="Your Name" />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Phone"
                                                    name="phone"
                                                    rules={[{ required: true, message: 'Please enter your phone' }]}
                                                >
                                                    <Input placeholder="Your phone" />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Email"
                                                    name="email"
                                                    rules={[{ required: true, message: 'Please enter your email' }]}
                                                >
                                                    <Input type="email" placeholder="Email Address" />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Message"
                                                    name="message"
                                                    rules={[{ required: true, message: 'Please enter your message' }]}
                                                >
                                                    <Input.TextArea rows={3} placeholder="Your message" />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit">Submit</Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </div>
                        </div>
                        <div className='main-section-course' style={{ padding: "20px" }}>
                            <div className='course-details-section'>
                                <div className='course-details-text'>
                                    <ul style={{ listStyle: "none" }} className="course-details-description">
                                        {courseDetails?.course_description?.map((desc: string, idx: number) => (
                                            <li key={idx} dangerouslySetInnerHTML={{ __html: desc }} />
                                        ))}
                                    </ul>
                                    {courseDetails?.subcourse_title === 'CFS' && (
                                        <div >
                                            <h2 style={{ textAlign: "center" }}>World's most affordable Finance certification</h2>
                                            <h2 style={{ textAlign: "center" }}>CFS® designation after your name signifies a commitment to excellence and professionalism, increasing trust and confidence in your expertise.</h2>
                                        </div>
                                    )}
                                    {courseDetails?.subcourse_title === 'CFS' && (
                                        <div>
                                            <h2 style={{ fontSize: "1.5rem", color: "#008fa8" }}>Authorized Use of CFS Post-nominal Letters</h2>
                                            <p className="course-details-description">By successfully passing the CFS examination, you are authorized to use the CFS post-nominal letters after your name for a lifetime.</p>
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', gap: '12px', marginTop: '16px', flexWrap: 'wrap', justifyContent: "center" }}>
                                        <Button type="primary">
                                            <a
                                                href={courseDetails?.course_Brousher}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'white', textDecoration: 'none' }}
                                            >
                                                View Brochure
                                            </a>
                                        </Button>



                                        <Button type="primary" onClick={() => setIsEligibilityModalOpen(true)}>
                                            Check Eligibility
                                        </Button>
                                    </div>


                                </div>

                                <div className="course-details-image">
                                    <img
                                        src={courseDetails.course_certificate_image || defalut}
                                        alt="Course Certificate"
                                        style={{
                                            height:
                                                courseDetails.subcourse_title?.toLowerCase().includes('ifrs') ||
                                                    courseDetails.course_title?.toLowerCase().includes('ifrs')
                                                    ? '600px'
                                                    : 'auto',
                                            width: '90%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>


                            </div>

                            {courseDetails?.subcourse_title === 'CFS' && (
                                <div className="cfs-course-details">
                                    <h2 className="homepage-heading">Entry Requirements:</h2>
                                    <p>If you have a minimum one year of working experience at any level of finance, accounting or related
                                        role, then you are eligible to sit for the CFS® exam. One year experience is the only eligibility requirement.
                                        We will require you to provide your experience details (such as name and address of
                                        your current/previous organization) at the time of your exam registration.</p>
                                    <p>
                                        To become a CFS designation holder, a candidate must fulfil the following requirements:</p>
                                    <ul >
                                        <li>Register and start preparation with Meantoir Global Academy in India</li>
                                        <li>Once your preparation is complete, you can take CFS exam any time of the year. Pass an examination by having at
                                            least 30 (60%) correct answers out of 50 multiple choice questions.</li>

                                    </ul>
                                    {/* <p style={{ textAlign: "center", fontSize: "18px" }}> Course Duration: {courseDetails.course_duration}</p> */}
                                </div>
                            )}
                            {courseDetails?.subcourse_title === 'IFRS' && (
                                <><h2 className="homepage-heading">Key Objectives of IFRS</h2><div className="contact-container-card">

                                    <div className="flip-card">
                                        <div className="flip-card-inner">
                                            <div className="flip-card-front">

                                                <strong>Transparency</strong>
                                            </div>
                                            <div className="flip-card-back">
                                                <p>Enhance clarity and trust in financial reporting.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flip-card">
                                        <div className="flip-card-inner">
                                            <div className="flip-card-front">

                                                <strong>Comparability</strong>
                                            </div>
                                            <div className="flip-card-back">
                                                <p>Ensure financial statements are consistent across different jurisdictions</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flip-card">
                                        <div className="flip-card-inner">
                                            <div className="flip-card-front">

                                                <strong>Efficiency</strong>
                                            </div>
                                            <div className="flip-card-back">
                                                <p>Reduce the cost of financial reporting for multinational companies.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flip-card">
                                        <div className="flip-card-inner">
                                            <div className="flip-card-front">

                                                <strong>Global Standardization</strong>
                                            </div>
                                            <div className="flip-card-back">
                                                <p>Align accounting practices worldwide</p>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                    <div className="home-why-wrapper">
                                        <div className="home-why-container">
                                            <div className="home-why-left">
                                                <h2 className="homepage-heading">Core Features of IFRS</h2>
                                                <div>
                                                    <ul className="home-why-list">
                                                        <li className="home-why-list-item"><b>Principle-Based :Focuses on general principles and professional judgment rather than detailed rules</b></li>
                                                        <li className="home-why-list-item"><b>Global Applicability :</b>Adopted or converged with by over 140 countries, including the EU, Canada,     and Australia.</li>
                                                        <li className="home-why-list-item"><b>Uniformity :</b>Encourages standardized reporting, making it easier for investors and stakeholders to compare financial statements.</li>

                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="home-why-right">
                                                <h2 className="homepage-heading">Benefits</h2>
                                                <div>
                                                    <ul className="home-why-list">
                                                        <li className="home-why-list-item"><b>Global Recognition:</b>Enhances career prospects in multinational organizations.</li>
                                                        <li className="home-why-list-item"><b>Practical Knowledge :</b>Focused on real-world application of IFRS</li>
                                                        <li className="home-why-list-item"><b>Skill Enhancement :</b>Adds technical expertise in financial reporting.</li>
                                                        <li className="home-why-list-item"><b>Job Opportunities :</b>In auditing, accounting, consulting, and regulatory roles.</li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="course-details-tabs-container">
                                <div className="course-details-tabs">
                                    <Tabs
                                        activeKey={activeTab}
                                        onChange={setActiveTab}
                                        type="card"
                                        className="custom-tabs"
                                        items={tabItems}
                                        centered
                                    />
                                </div>
                            </div>

                            {courseDetails?.subcourse_title === 'CFS' && (
                                <>
                                    <h2 className="homepage-heading">Accreditation of CFS Certification</h2><div className='course-details-section'>
                                        <div className='course-details-text'>
                                            <div className="cfs-info-section">
                                                <div className="cfs-info-block">
                                                    <img src={cfs1} alt="CFS finance course India" className="course-calendar-image" />
                                                    <div className="cfs-info-text">
                                                        <p>
                                                            CFS certification is accredited as a Level 7 qualification within the UK's national qualifications framework, aligning with the SCQF standards.
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="cfs-info-block">
                                                    <img src={cfs2} alt="CFS course Kerala" className="course-calendar-image" />
                                                    <div className="cfs-info-text">
                                                        <p>
                                                            In accordance with the European Qualifications Framework (EQF), CFS certification is categorized as a Level 5 qualification.
                                                        </p>
                                                        <p>
                                                            CFS certification has received external accreditation from the University of the West of Scotland.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                        <div className='course-details-images'>

                                            <img
                                                src={cfsbody}
                                                alt="CFS course Kerala" />
                                        </div>

                                    </div></>
                            )}
                            {courseDetails?.subcourse_title === 'IFRS' && (
                                <><h2 className="homepage-heading">To become a 'Diploma  in IFRS' certificate holder, a candidate must fulfil the following requirements:</h2>
                                    <div>
                                        <ul className="ifrs-requirements-list">
                                            <li>Register and start preparation with Meantoir Global Academy in India.</li>
                                            <li>Once your preparation is complete, you can take 'Diploma in IFRS' exam any time of the year. </li>
                                        </ul>
                                    </div></>
                            )}
                            <div className="home-why-wrapper">
                                <div className="home-why-container">
                                    <div className="home-why-left">
                                        <h2 className="homepage-heading">Why Choose Us</h2>
                                        <ul className="home-why-list">
                                            {whyTexts.map((text, index) => (
                                                <li key={index} className="home-why-list-item"> {text}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="home-why-right">
                                        <img src={why1} alt="CFM financial management course India,CFS course Kerala" className="home-why-image" />
                                    </div>
                                </div>
                            </div>


                            <div>
                                <div className='course-details-text2'>
                                    <h2 className="homepage-heading">
                                        Course  {['CFS', 'IFRS'].includes(courseDetails?.subcourse_title) ? 'Syllabus' : 'Modules'}
                                    </h2>
                                    {courseModuleData.length === 0 && <p>No modules available.</p>}

                                    <div className="course-card-grid">
                                        {courseModuleData.map((module: any, index: number) => {
                                            const isExpanded = expandedCards[index] || false;
                                            const descriptions = Array.isArray(module.course_module_description)
                                                ? module.course_module_description
                                                : [module.course_module_description];

                                            return (
                                                <div key={module.id} className="course-card">
                                                    <div className="course-card-content">
                                                        <h2 className="course-card-title">{module.course_module_Title}</h2>

                                                        {!['CFS', 'IFRS'].includes(courseDetails?.subcourse_title) && (
                                                            <>
                                                                <h3 className="course-card-subtitle">{module.course_module_subTitle}</h3>

                                                                <div className={`course-card-description-container ${isExpanded ? 'expanded' : ''}`}>
                                                                    <ul className="course-card-description">
                                                                        {descriptions.map((desc: string, i: number) => (
                                                                            <li key={i}>{desc}</li>
                                                                        ))}
                                                                    </ul>
                                                                </div>

                                                                {descriptions.length > 3 && (
                                                                    <button
                                                                        className="course-card-readmore"
                                                                        onClick={() => toggleReadMore(index)}
                                                                    >
                                                                        {isExpanded ? 'Show Less' : 'Read More'}
                                                                    </button>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                <Modal
                                    title="Check Eligibility"
                                    open={isEligibilityModalOpen}
                                    onCancel={() => setIsEligibilityModalOpen(false)}
                                    footer={null}
                                    width={600}
                                >
                                    <EligibilityCheckForm
                                        courseId={id ? Number(id) : 0}
                                        onClose={() => setIsEligibilityModalOpen(false)}
                                    />
                                </Modal>
                            </div>
                        </div>
                        {courseDetails?.subcourse_title === 'CFS' && (
                            <div className="course-details-faq">
                                <h2 className="homepage-heading">Frequently Asked Questions </h2>
                                <div >
                                    <h3 onClick={() => toggleSection(" What is the role")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                        What is the role of a Financial Specialist?
                                    </h3>
                                    {openSection === " What is the role" && (
                                        <>
                                            <p style={{ fontSize: "1.5rem", }}>
                                                A Financial Specialist is responsible for providing expertise and guidance in various financial areas,
                                                such as investment, risk management, taxation, or financial planning, to help individuals or
                                                organizations make informed financial decisions and achieve their financial goals.
                                            </p>
                                        </>
                                    )}
                                </div>
                                <div >
                                    <h3 onClick={() => toggleSection("What is the difference between")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                        What is the difference between a financial specialist and an accountant?
                                    </h3>
                                    {openSection === "What is the difference between" && (
                                        <>
                                            <p style={{ fontSize: "1.5rem", }}>
                                                A Financial Specialist provides expertise in areas like investment and financial planning, guiding
                                                individuals or organizations in making strategic financial decisions. An Accountant, on the other hand,
                                                primarily focuses on financial record-keeping, preparing and analyzing financial statements, and ensuring
                                                compliance with tax laws and regulations. While there is overlap, a Financial Specialist offers broader
                                                financial guidance, whereas
                                                an accountant deals with specific financial reporting and compliance tasks.
                                            </p>
                                        </>
                                    )}
                                </div>
                                <div >
                                    <h3 onClick={() => toggleSection("What is the difference between Financial Analyst")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                        What is the difference between Financial Analyst and Financial Specialist?
                                    </h3>
                                    {openSection === "What is the difference between Financial Analyst" && (
                                        <>
                                            <p style={{ fontSize: "1.5rem", }}>
                                                A Financial Analyst analyzes financial data to help organizations make investment decisions,
                                                while a Financial Specialist provides expertise in various financial areas such as planning, risk
                                                management, or taxation, guiding individuals or organizations to make informed financial choices.
                                                Financial Analysts focus on investments,
                                                whereas Financial Specialists offer broader financial advisory services.
                                            </p>
                                        </>
                                    )}
                                </div>
                                <div >
                                    <h3 onClick={() => toggleSection("What does a corporate finance specialist do?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                        What does a corporate finance specialist do?
                                    </h3>
                                    {openSection === "What does a corporate finance specialist do?" && (
                                        <>
                                            <p style={{ fontSize: "1.5rem", }}>
                                                A corporate Finance Specialist is responsible for managing a company’s financial activities,
                                                including financial planning, budgeting, investment analysis, and capital structuring. They help businesses
                                                make strategic financial decisions, optimize capital allocation,
                                                and ensure long-term financial stability and growth.
                                            </p>
                                        </>
                                    )}
                                </div>
                                <div >
                                    <h3 onClick={() => toggleSection("What is the difference between a Financial Advisor and a Financial")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                        What is the difference between a Financial Advisor and a Financial Consultant?
                                    </h3>
                                    {openSection === "What is the difference between a Financial Advisor and a Financial" && (
                                        <>
                                            <p style={{ fontSize: "1.5rem", }}>
                                                A Financial Advisor provides personalized financial guidance and investment
                                                recommendations to individuals or businesses, focusing on wealth management and financial planning.
                                                A Financial Consultant, on the other hand, offers broader financial advice to organizations, assisting
                                                with various aspects like mergers, acquisitions, or restructuring. While there is overlap, Financial Advisors
                                                typically work with individuals, while Financial Consultants
                                                work with businesses on diverse financial projects.
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                        <h2 className="homepage-heading">Explore More Courses</h2>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>

                            <CourseDisplayCard />
                        </div>

                    </div>
                    <Footer />
                </div>
            )
            }
        </div >
    );
}

export default CourseDetails;
